import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function formatDateWithMicroseconds(date: Date) {
    let yyyy = date.getFullYear();
    let mm = String(date.getMonth() + 1).padStart(2, '0');
    let dd = String(date.getDate()).padStart(2, '0');
    let hh = String(date.getHours()).padStart(2, '0');
    let min = String(date.getMinutes()).padStart(2, '0');
    let ss = String(date.getSeconds()).padStart(2, '0');
    let ms = String(date.getMilliseconds()).padStart(3, '0'); // Milliseconds (3 digits)
    let extraDigits = String(Math.floor(Math.random() * 1000)).padStart(3, '0'); // Fake microseconds

    return `${yyyy}-${mm}-${dd} ${hh}:${min}:${ss}.${ms}${extraDigits}`;
}

